// import React, { useEffect, useState } from "react";
// import { Modal, Table, Typography, Button, message } from "antd";
// import axios from "axios";
// import { ExclamationCircleOutlined } from "@ant-design/icons";

// const { confirm } = Modal;

// const LeaveManagementModal = ({
//   visible,
//   onClose,
//   userId,
//   workLogId,
//   onLeaveUpdated,
// }) => {
//   const [leaveData, setLeaveData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [approving, setApproving] = useState(false);
//   const apiUrl = process.env.REACT_APP_API_URL;

//   // Fetch leave data when modal is opened
//   useEffect(() => {
//     if (visible && userId) {
//       fetchLeaveData();
//     }
//   }, [visible, userId]);

//   const fetchLeaveData = async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(
//         `${apiUrl}/api/worklogs/calculateLeaveData/${userId}`
//       );
//       setLeaveData(data);
//       console.log(data);
//     } catch (error) {
//       console.error("Fetch error:", error);
//       message.error("Failed to fetch leave data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApprove = () => {
//     if (!workLogId) {
//       message.error("Invalid Work Log ID.");
//       return;
//     }

//     confirm({
//       title: "Approve Leave Request?",
//       icon: <ExclamationCircleOutlined />,
//       content: "Are you sure you want to approve this leave request?",
//       okText: "Approve",
//       cancelText: "Cancel",
//       onOk: async () => {
//         setApproving(true);
//         try {
//           await axios.put(
//             `${apiUrl}/api/worklogs/approveLeaveRequest/${workLogId}`
//           );
//           message.success("Leave approved successfully.");
//           fetchLeaveData(); // Optional: refresh balance
//           onClose(); // Optionally close modal after approval
//           onLeaveUpdated(); // Call the callback to refresh the parent component
//         } catch (error) {
//           console.error("Approval error:", error);
//           message.error(
//             error.response?.data?.message || "Failed to approve leave."
//           );
//         } finally {
//           setApproving(false);
//         }
//       },
//     });
//   };

//   const nonLOPColumns = [
//     { title: "Leave Type", dataIndex: "type", key: "type" },
//     { title: "This Month(taken)", dataIndex: "thisMonth", key: "thisMonth" },
//     { title: "Overall(Available)", dataIndex: "overall", key: "overall" },
//   ];

//   const totalLeavesColumns = [
//     { title: "Leave Type", dataIndex: "type", key: "type" },
//     { title: "This Month(Taken)", dataIndex: "thisMonth", key: "thisMonth" },
//     { title: "Overall(Taken)", dataIndex: "overall", key: "overall" },
//   ];
//   const nonLOPData = [
//     {
//       key: "1",
//       type: "Sick",
//       thisMonth: leaveData?.nonLOPLeavesAvailable?.sick?.thisMonth ?? 0,
//       overall: leaveData?.nonLOPLeavesAvailable?.sick?.overall ?? 0,
//     },
//     {
//       key: "2",
//       type: "Casual",
//       thisMonth: leaveData?.nonLOPLeavesAvailable?.casual?.thisMonth ?? 0,
//       overall: leaveData?.nonLOPLeavesAvailable?.casual?.overall ?? 0,
//     },
//   ];

//   const totalLeavesData = [
//     {
//       key: "1",
//       type: "LOP",
//       thisMonth: leaveData?.totalLeavesTaken?.lop?.thisMonth ?? 0,
//       overall: leaveData?.totalLeavesTaken?.lop?.overall ?? 0,
//     },
//     {
//       key: "2",
//       type: "Sick",
//       thisMonth: leaveData?.totalLeavesTaken?.sick?.thisMonth ?? 0,
//       overall: leaveData?.totalLeavesTaken?.sick?.overall ?? 0,
//     },
//     {
//       key: "3",
//       type: "Casual",
//       thisMonth: leaveData?.totalLeavesTaken?.casual?.thisMonth ?? 0,
//       overall: leaveData?.totalLeavesTaken?.casual?.overall ?? 0,
//     },
//   ];

//   return (
//     <Modal
//       title="Leave Management"
//       open={visible}
//       onCancel={onClose}
//       footer={[
//         <Button key="close" onClick={onClose} disabled={approving}>
//           Close
//         </Button>,
//         <Button
//           key="approve"
//           type="primary"
//           loading={approving}
//           onClick={handleApprove}
//           disabled={leaveData?.totalLeavesTaken?.status === "approved"}
//         >
//           Approve
//         </Button>,
//       ]}
//       width={700}
//       centered
//       destroyOnClose
//     >
//       <Typography.Title level={5}>Non-LOP Leaves Available</Typography.Title>
//       <Table
//         bordered
//         size="small"
//         loading={loading}
//         pagination={false}
//         columns={nonLOPColumns}
//         dataSource={nonLOPData}
//         rowKey="key"
//       />

//       <Typography.Title level={5} style={{ marginTop: 20 }}>
//         Total Leaves Taken
//       </Typography.Title>
//       <Table
//         bordered
//         size="small"
//         loading={loading}
//         pagination={false}
//         columns={totalLeavesColumns}
//         dataSource={totalLeavesData}
//         rowKey="key"
//       />
//     </Modal>
//   );
// };

// export default LeaveManagementModal;



import React, { useEffect, useState } from "react";
import { Modal, Table, Typography, Button, message, Descriptions } from "antd";
import axios from "axios";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { confirm } = Modal;

const LeaveManagementModal = ({
  visible,
  onClose,
  userId,
  workLogId,
  onLeaveUpdated,
}) => {
  const [leaveData, setLeaveData] = useState(null);
  const [workLog, setWorkLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  // 🔹 Fetch WorkLog + Leave Balance
  useEffect(() => {
    if (visible && userId && workLogId) {
      fetchWorkLog();
      fetchLeaveData();
    }
  }, [visible, userId, workLogId]);

  const fetchWorkLog = async () => {
    try {
      const res = await axios.get(
        `${apiUrl}/api/worklogs/getWorkLogById/${workLogId}`
      );
      setWorkLog(res.data.workLog);
      // console.log(res.data.workLog);
    } catch (err) {
      message.error("Failed to fetch work log");
    }
  };

  const fetchLeaveData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${apiUrl}/api/worklogs/calculateLeaveData/${userId}`
      );
      console.log(res.data, "fetch leave data")
      setLeaveData(res.data);
    } catch (error) {
      message.error("Failed to fetch leave data");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Approve
  const handleApprove = () => {
    confirm({
      title: "Approve Request?",
      icon: <ExclamationCircleOutlined />,
      okText: "Approve",
      cancelText: "Cancel",
      onOk: async () => {
        setApproving(true);
        try {
          await axios.put(
            `${apiUrl}/api/worklogs/approveLeaveRequest/${workLogId}`
          );
          message.success("Approved successfully");
          onClose();
          onLeaveUpdated();
        } catch (err) {
          message.error(
            err?.response?.data?.message || "Approval failed"
          );
        } finally {
          setApproving(false);
        }
      },
    });
  };

  // 🔹 TABLE CONFIG
  const nonLOPColumns = [
    { title: "Leave Type", dataIndex: "type" },
    { title: "This Month", dataIndex: "thisMonth" },
    { title: "Available", dataIndex: "overall" },
  ];

  const totalLeavesColumns = [
    { title: "Leave Type", dataIndex: "type" },
    { title: "This Month", dataIndex: "thisMonth" },
    { title: "Overall", dataIndex: "overall" },
  ];


  const nonLOPData = [
    {
      key: "1",
      type: "Sick",
      thisMonth: leaveData?.nonLOPLeavesAvailable?.sick?.thisMonth ?? 0,
      overall: leaveData?.nonLOPLeavesAvailable?.sick?.overall ?? 0,
    },
    {
      key: "2",
      type: "Casual",
      thisMonth: leaveData?.nonLOPLeavesAvailable?.casual?.thisMonth ?? 0,
      overall: leaveData?.nonLOPLeavesAvailable?.casual?.overall ?? 0,
    },
    // {
    //   key: "3",
    //   type: "Compensation",
    //   thisMonth: "-",
    //   overall: leaveData?.compensation?.available ?? 0,
    // },
  ];

  const totalLeavesData = [
    {
      key: "1",
      type: "LOP",
      thisMonth: leaveData?.totalLeavesTaken?.lop?.thisMonth ?? 0,
      overall: leaveData?.totalLeavesTaken?.lop?.overall ?? 0,
    },
    {
      key: "2",
      type: "Sick",
      thisMonth: leaveData?.totalLeavesTaken?.sick?.thisMonth ?? 0,
      overall: leaveData?.totalLeavesTaken?.sick?.overall ?? 0,
    },
    {
      key: "3",
      type: "Casual",
      thisMonth: leaveData?.totalLeavesTaken?.casual?.thisMonth ?? 0,
      overall: leaveData?.totalLeavesTaken?.casual?.overall ?? 0,
    },
    // {
    //   key: "4",
    //   type: "Compensation",
    //   thisMonth: "-",
    //   overall: leaveData?.compensation?.total ?? 0,
    // },
  ];
  const compensationLeaveCount = [
    { key: "1", type: "Compensation Leave Taken", available: leaveData?.compensation?.available ?? 0, used: leaveData?.compensation?.used ?? 0, overall: leaveData?.compensation?.total ?? 0 },
  ];

  const totalCompensationLeavesColumns = [
    { title: "Leave Type", dataIndex: "type" },
    { title: "Used", dataIndex: "used" },
    { title: "Available", dataIndex: "available" },
    { title: "Overall", dataIndex: "overall" },
  ];
  const isPermission = workLog?.workType === "permission";

  return (
    <Modal
      title="Leave Management"
      open={visible}
      onCancel={onClose}
      width={720}
      centered
      destroyOnClose
      footer={[
        <Button key="close" onClick={onClose} disabled={approving}>
          Close
        </Button>,
        <Button
          key="approve"
          type="primary"
          loading={approving}
          onClick={handleApprove}
          disabled={workLog?.leaveStatus === "approved"}
        >
          Approve
        </Button>,
      ]}
    >
      {/* 🔹 PERMISSION UI */}
      {isPermission && (
        <>
          <Typography.Title level={5}>
            Permission Request
          </Typography.Title>

          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Permission Hours">
              {workLog?.permissionHours} Hour(s)
            </Descriptions.Item>
            <Descriptions.Item label="Reason">
              {workLog?.reason}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              {workLog?.leaveStatus?.toUpperCase()}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}

      {/* 🔹 LEAVE UI */}
      {!isPermission && (
        <>
          <Typography.Title level={5}>
            Non-LOP Leaves Available
          </Typography.Title>
          <Table
            bordered
            size="small"
            loading={loading}
            pagination={false}
            columns={nonLOPColumns}
            dataSource={nonLOPData}
          />

          <Typography.Title level={5} style={{ marginTop: 20 }}>
            Total Leaves Taken
          </Typography.Title>
          <Table
            bordered
            size="small"
            loading={loading}
            pagination={false}
            columns={totalLeavesColumns}
            dataSource={totalLeavesData}
          />

          <Typography.Title level={5} style={{ marginTop: 20 }}>
            Compensation Leave Details
          </Typography.Title>
          <Table
            bordered
            size="small"
            loading={loading}
            pagination={false}
            columns={totalCompensationLeavesColumns}
            dataSource={compensationLeaveCount}
          />

        </>
      )}
    </Modal>
  );
};

export default LeaveManagementModal;
